import * as React from "react";
import type { ReactNode } from "react";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import Footer from "./Footer";
import Header from "./Header";

type LayoutProps = {
  children: ReactNode;
  location?: {
    pathname: string;
  };
};

export default function Layout({ children, location }: LayoutProps) {
  const { language } = useI18next();
  const { t } = useTranslation();
  const shouldReduceMotion = useReducedMotion();
  const normalizedLanguage = language.split("-")[0];
  const rtlLanguages = ["ar", "ur", "ps"];
  const dir = rtlLanguages.includes(normalizedLanguage) ? "rtl" : "ltr";

  return (
    <div dir={dir} style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <a href="#main" className="skip-link">
        {t("a11y.skipToContent")}
      </a>
      <Header pathname={location?.pathname} />
      <AnimatePresence mode="wait" initial={false}>
        <motion.main
          id="main"
          key={location?.pathname ?? "page"}
          style={{ flex: 1, paddingTop: 22, paddingBottom: 28 }}
          initial={shouldReduceMotion ? false : { opacity: 0, y: 8 }}
          animate={shouldReduceMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
          exit={shouldReduceMotion ? { opacity: 1 } : { opacity: 0, y: -8 }}
          transition={{ duration: 0.22, ease: "easeOut" }}
        >
          {children}
        </motion.main>
      </AnimatePresence>
      <Footer />
    </div>
  );
}
